'use strict';
module.exports = require('./Toast.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/toast/index.js
// module id = 33
// module chunks = 1